module.exports = __webpack_public_path__ + "static/media/italian-dolomite.84e4f4a9.jpeg";